import React, { useEffect, useState } from "react";
import "./index.css";
import External from "./components/ExternalUser";
import { AuthenticateDocument } from "./utils/AuthenticateDocument";
import MainLayout from "./components/MainLayout";
import { useDocument } from "./context/documentInfoContex";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

function App({ isExternal = false, isTemplateDocument = false }) {
  
  const { id } = useParams();
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const { conflictPreviewVerion, setConflictPreviewVerion, setIsReadOnly, setIsTemplateDocument } = useDocument();

  useEffect(() => {
    setIsTemplateDocument(isTemplateDocument);
    const searchParams = new URLSearchParams(document.location.search)
    const previewVerion = searchParams.get("versionType");
    
    if (previewVerion) {
      setConflictPreviewVerion(previewVerion);
      setIsReadOnly(true);
    }
  }, [id]);

  return (
    <div className='App'>
      {isExternal ? (
        <External />
      ) : isAuthenticating && !conflictPreviewVerion ? (
        <AuthenticateDocument setIsLoading={setIsAuthenticating} />
      ) : (
        <MainLayout />
      )}
    </div>
  );
}

export default App;
